import React, { useState, useEffect } from 'react';
import { ToastType } from '../utils/toast';

interface ToastItem {
  id: number;
  message: string;
  type: ToastType;
  exiting?: boolean;
}

const ICONS: Record<ToastType, string> = {
  success: '✓',
  error: '✕',
  warning: '⚠',
  info: 'ℹ',
};

let _id = 0;

export default function MelaToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const handler = (e: Event) => {
      const { message, type } = (e as CustomEvent<{ message: string; type: ToastType }>).detail;
      const id = ++_id;
      setToasts(prev => [...prev, { id, message, type }]);
      setTimeout(() => {
        setToasts(prev => prev.map(x => x.id === id ? { ...x, exiting: true } : x));
        setTimeout(() => setToasts(prev => prev.filter(x => x.id !== id)), 300);
      }, 3700);
    };
    window.addEventListener('mela-toast', handler);
    return () => window.removeEventListener('mela-toast', handler);
  }, []);

  if (!toasts.length) return null;

  return (
    <div className="m-toast-cnt">
      {toasts.map(t => (
        <div
          key={t.id}
          className={`m-toast m-toast-${t.type}${t.exiting ? ' m-toast-exit' : ''}`}
        >
          <span className="m-toast-ico">{ICONS[t.type]}</span>
          <span>{t.message}</span>
        </div>
      ))}
    </div>
  );
}
